<template>
    <div class="mt-[45px]" data-cy="plugin-settings-index">
        <div class="flex flex-wrap justify-between">
            <h1
                class="text-2xl font-medium leading-normal tracking-small text-gray-800"
            >
                Plugin
            </h1>
            <AtomicButton
                v-if="teamPluginEnabled"
                color="yellow"
                size="lg"
                data-cy="plugin-settings-create-token"
                @click="createTokenModal = true"
            >
                <template #icon>
                    <PlusCircleIcon class="mr-2 h-6 w-6" />
                </template>
                New API Token
            </AtomicButton>
        </div>

        <div
            v-if="!teamPluginEnabled"
            class="mt-[19px] rounded-[6px] bg-white shadow-card"
        >
            <div class="px-6">
                <div class="flex flex-col sm:flex-row">
                    <svg
                        class="ml-6 mt-10 flex shrink-0 sm:ml-0"
                        width="38"
                        height="38"
                        viewBox="0 0 38 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M19 11V22M19 27H19.02M37 19C37 21.3638 36.5344 23.7044 35.6298 25.8883C34.7252 28.0722 33.3994 30.0565 31.7279 31.7279C30.0565 33.3994 28.0722 34.7252 25.8883 35.6298C23.7044 36.5344 21.3638 37 19 37C16.6362 37 14.2956 36.5344 12.1117 35.6298C9.92784 34.7252 7.94353 33.3994 6.27208 31.7279C4.60062 30.0565 3.27475 28.0722 2.37017 25.8883C1.46558 23.7044 1 21.3638 1 19C1 14.2261 2.89642 9.64773 6.27208 6.27208C9.64773 2.89642 14.2261 1 19 1C23.7739 1 28.3523 2.89642 31.7279 6.27208C35.1036 9.64773 37 14.2261 37 19Z"
                            stroke="#FFC000"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                    <div class="ml-6 mt-6 sm:mt-[46px]">
                        <p class="font-medium leading-normal text-gray-800">
                            In order to use TOPOL.io Plugin you need to enable
                            it for your account first.
                        </p>
                        <div
                            class="mt-3.5 max-w-[550px] text-sm leading-normal text-gray-500"
                        >
                            <p>
                                TOPOL.io Plugin is a version of TOPOL.io editor
                                which can be embedded into your platform. You
                                will get a white label version of email template
                                editor that can be used by your users.
                            </p>
                            <br />
                            <p>
                                <a href="https://docs.topol.io/" target="_blank"
                                    ><span
                                        class="font-medium text-topol-blue-500 hover:text-topol-blue-600"
                                        >Check out our documentation</span
                                    ></a
                                >
                                how to create API Token, embed plugin, setup
                                custom data storage and more.
                            </p>
                        </div>
                        <AtomicButton
                            color="yellow"
                            size="lg"
                            class="mb-[67px] mt-[31px]"
                            data-cy="enable-plugin"
                            @click="enablePlugin"
                        >
                            <template #icon>
                                <div class="mr-2">
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M10.8333 2.5V8.33333H16.6666L9.16658 17.5V11.6667H3.33325L10.8333 2.5Z"
                                            stroke="#252F3F"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </div>
                            </template>
                            Setup plugin
                        </AtomicButton>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="mb-20">
            <div class="mt-4 grid-cols-layout pb-5 lg:grid">
                <div class="mb-6 lg:mb-0 lg:mt-4">
                    <h3
                        class="mb-[5px] text-lg font-medium leading-normal tracking-small text-gray-800"
                    >
                        Active API Tokens
                    </h3>
                    <p class="max-w-xs text-sm text-gray-500">
                        API tokens are used to access Topol Plugin.
                    </p>
                </div>

                <div
                    v-if="loadedTokens.length === 0"
                    class="rounded-[6px] bg-white shadow-card"
                >
                    <div class="px-6">
                        <div class="flex flex-col sm:flex-row">
                            <svg
                                class="ml-6 mt-10 flex shrink-0 sm:ml-0"
                                width="38"
                                height="38"
                                viewBox="0 0 38 38"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M19 11V22M19 27H19.02M37 19C37 21.3638 36.5344 23.7044 35.6298 25.8883C34.7252 28.0722 33.3994 30.0565 31.7279 31.7279C30.0565 33.3994 28.0722 34.7252 25.8883 35.6298C23.7044 36.5344 21.3638 37 19 37C16.6362 37 14.2956 36.5344 12.1117 35.6298C9.92784 34.7252 7.94353 33.3994 6.27208 31.7279C4.60062 30.0565 3.27475 28.0722 2.37017 25.8883C1.46558 23.7044 1 21.3638 1 19C1 14.2261 2.89642 9.64773 6.27208 6.27208C9.64773 2.89642 14.2261 1 19 1C23.7739 1 28.3523 2.89642 31.7279 6.27208C35.1036 9.64773 37 14.2261 37 19Z"
                                    stroke="#FFC000"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>

                            <div class="ml-6 mt-6 sm:mt-[46px]">
                                <p
                                    class="font-medium leading-normal text-gray-800"
                                >
                                    You have no active API Tokens at the moment.
                                </p>
                                <div
                                    class="mb-12 mt-3.5 max-w-[550px] text-sm leading-normal text-gray-500"
                                >
                                    <p>
                                        To embed TOPOL.io Plugin first create an
                                        active API Token for your app.
                                    </p>
                                    <br />
                                    <p>
                                        <a
                                            href="https://docs.topol.io"
                                            target="_blank"
                                            ><span
                                                class="font-medium text-topol-blue-500 hover:text-topol-blue-600"
                                                >Check out our
                                                documentation</span
                                            ></a
                                        >
                                        how to create API Token, embed plugin,
                                        setup custom data storage and more.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else>
                    <InfiniteScroll data="tokens" preserve-url class="-mb-10">
                        <Tokens
                            :tokens="loadedTokens"
                            @selectModal="showRemoveTokenModal"
                            @show-gcs-modal="showStorageProviderModal($event, 'gcs')"
                            @show-aws-modal="showStorageProviderModal($event, 'aws')"
                            @show-cloudflare-modal="
                                showStorageProviderModal($event, 'cloudflare')
                            "
                            @show-digital-ocean-modal="
                                showStorageProviderModal($event, 'digitalocean')
                            "
                            @openAISettingsModal="showOpenAISettingsModal"
                            @showCopyTokenModal="showCopyTokenModal"
                        />

                        <template #loading>
                            <div class="mb-10 flex justify-center">
                                <LoadingSpinner size="large" />
                            </div>
                        </template>
                    </InfiniteScroll>
                </div>
            </div>

            <div
                v-if="loadedTokens.length > 0"
                class="grid-cols-layout border-t border-gray-300 pt-5 lg:grid"
            >
                <div class="mb-6 lg:mb-0 lg:mt-4">
                    <h3
                        class="mb-[5px] text-lg font-medium leading-normal tracking-small text-gray-800"
                    >
                        Disable plugin
                    </h3>
                </div>
                <div class="rounded-[6px] bg-white shadow-card">
                    <div class="border-b border-gray-200 px-6">
                        <p class="pt-6 text-sm leading-normal text-gray-500">
                            After disabling plugin, all of your active API
                            Tokens will be expired.<br />
                            You will not be able to initialize TOPOL.io editor
                            in your application.
                        </p>
                        <div class="mb-6 mt-[23px]">
                            <label
                                class="flex"
                                data-cy="disable-plugin-delete-confirmation"
                            >
                                <CheckboxInput
                                    v-model:checked="deleteConfirmation"
                                    class="mt-[1px]"
                                    size="md"
                                    name="deleteConfirmation"
                                />
                                <p
                                    class="ml-1 cursor-pointer select-none text-sm leading-normal text-gray-900"
                                >
                                    Confirm that you want to disable TOPOL.io
                                    Plugin on your account.
                                </p>
                            </label>
                        </div>
                    </div>

                    <div class="flex justify-end">
                        <div class="my-3 pr-6">
                            <AtomicButton
                                :disabled="!deleteConfirmation || loading"
                                data-cy="disable-plugin"
                                color="red"
                                size="sm"
                                @click="disablePlugin"
                            >
                                Disable plugin
                            </AtomicButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <CreateTokenModal
            v-if="createTokenModal"
            @close="closeCreateTokenModal"
        />

        <RemoveTokenModal
            v-if="removeTokenModal"
            :token="selectedToken"
            :loading="removeTokenLoading"
            @remove="removeToken"
            @close="removeTokenModal = false"
        />
        <StorageModal
            v-if="storageModal && storageProvider"
            :provider="storageProvider"
            :has-storage-settings-enabled="hasStorageSettingsEnabled"
            :token="selectedToken"
            :page="tokenPage(selectedToken.id)"
            @close="closeStorageModal"
            @deleteModal="deleteStorageModalShow"
        />
        <DeleteStorageModal
            v-if="deleteStorageModal && storageProvider"
            :provider="storageProvider"
            :token="selectedToken"
            @close="closeDeleteStorageModal"
            @deleteStorage="deleteStorage"
        />
        <OpenAISettingsModal
            v-if="openAISettingsModal"
            :token="selectedToken"
            @close="openAISettingsModal = false"
            @save="saveOpenAISettings"
            @delete="deleteOpenAISettings"
        />
        <CopyTokenApiKeyModal
            v-if="copyTokenModal"
            :api-token="selectedToken"
            :page="tokenPage(selectedToken.id)"
            @close="copyTokenModal = false"
        />
    </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';
import { InfiniteScroll, router } from '@inertiajs/vue3';
import AtomicButton from '@atomic/Buttons/AtomicButton.vue';
import CheckboxInput from '@atomic/Inputs/CheckboxInput.vue';
import axios from 'axios';
import { route } from 'ziggy-js';
import IToken from '@/types/Plugin/IToken';
import { create } from '@composables/useNotifications';
import { PlusCircleIcon } from '@heroicons/vue/24/outline';
import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import ISubscription from '@/types/Subscription/ISubscription';

const { show: showConfirmation } = useConfirm();

const props = defineProps({
    teamPluginEnabled: {
        type: Boolean,
        default: false,
    },
    tokens: {
        type: Object as PropType<{ data: IToken[]; per_page: number }>,
        default: () => ({ data: [], per_page: 10 }),
    },
    pluginSubscription: {
        type: Object as PropType<ISubscription>,
        default: () => null,
    },
    features: {
        type: Object,
        default: () => ({}),
    },
    hasStorageSettingsEnabled: {
        type: Boolean,
        default: false,
    },
});

const storageProvider = ref<
    'aws' | 'gcs' | 'cloudflare' | 'digitalocean' | null
>(null);
const storageModal = ref(false);
const createTokenModal = ref(false);
const loading = ref(false);
const selectedTokenId = ref('');
const removeTokenModal = ref(false);
const removeTokenLoading = ref(false);
const deleteStorageModal = ref(false);
const openAISettingsModal = ref(false);
const deleteConfirmation = ref(false);
const copyTokenModal = ref(false);
const selectedToken = ref({} as IToken);

const loadedTokens = computed(() => props.tokens.data);

const tokenPage = (id: string): number =>
    Math.max(
        1,
        Math.floor(
            loadedTokens.value.findIndex((token) => token.id === id) /
                props.tokens.per_page
        ) + 1
    );

const deleteStorageModalShow = () => {
    storageModal.value = false;
    deleteStorageModal.value = true;
};

const deleteStorage = async (id: string) => {
    selectedTokenId.value = id;
    try {
        const res = await axios.delete(
            route('api-tokens.storage.delete', {
                apiToken: selectedTokenId.value,
            })
        );
        if (res.status === 204) {
            create({
                title: 'Custom storage detached',
                text: 'Your custom storage has been successfully detached. You are now using default Google Cloud storage.',
                type: 'success',
            });
            router.reload({
                only: ['tokens'],
                data: { page: tokenPage(id) },
                preserveUrl: true,
            });
            deleteStorageModal.value = false;
        }
    } catch (err) {
        return;
    }
};

const closeStorageModal = () => {
    storageProvider.value = null;
    storageModal.value = false;
};

const closeDeleteStorageModal = () => {
    storageProvider.value = null;
    deleteStorageModal.value = false;
};

const showStorageProviderModal = (
    id: string,
    provider: 'aws' | 'cloudflare' | 'gcs' | 'digitalocean'
) => {
    const token = loadedTokens.value.find((a) => a.id === id);
    if (token) {
        selectedToken.value = token;
    }
    selectedTokenId.value = id;
    storageProvider.value = provider;
    storageModal.value = true;
};

const showOpenAISettingsModal = (id: string) => {
    const token = loadedTokens.value.find((a) => a.id === id);
    if (token) {
        selectedToken.value = token;
        openAISettingsModal.value = true;
    }
};

const showCopyTokenModal = (id: string) => {
    const token = loadedTokens.value.find((a) => a.id === id);
    if (token) {
        selectedToken.value = token;
        copyTokenModal.value = true;
    }
};

const replaceToken = (token: IToken) => {
    router.replaceProp('tokens.data', (tokens: IToken[]) =>
        tokens.map((item) => (item.id === token.id ? token : item))
    );
};

const saveOpenAISettings = async (key: string) => {
    try {
        const res = await axios.post(
            route('api-tokens.open-ai-settings.store', {
                apiToken: selectedToken.value.id,
            }),
            {
                key: key,
            }
        );
        if (res.status === 200) {
            create({
                title: 'OpenAI settings saved',
                text: 'Your OpenAI settings have been successfully saved.',
                type: 'success',
            });
            replaceToken(res.data.token);
        }
    } catch (e) {
        return;
    } finally {
        openAISettingsModal.value = false;
    }
};

const deleteOpenAISettings = async () => {
    const confirmed = await showConfirmation({
        header: 'Confirmation',
        message: `Do you really want disable your OpenAI Text Assistant?`,
        type: 'danger',
    });

    if (confirmed) {
        try {
            const res = await axios.delete(
                route('api-tokens.open-ai-settings.delete', {
                    apiToken: selectedToken.value.id,
                })
            );
            if (res.status === 204) {
                create({
                    title: 'OpenAI Text Assistant disabled',
                    text: 'Your OpenAI Text Assistant has been successfully disabled.',
                    type: 'success',
                });
                const settings = { ...selectedToken.value.settings };
                delete settings.open_ai_api_key;
                replaceToken({ ...selectedToken.value, settings });
            }
        } catch (e) {
            return;
        } finally {
            openAISettingsModal.value = false;
        }
    }
};

const enablePlugin = () => {
    const globalProps = computed(() => usePage<ITopolPageProps>().props);
    if (
        props.pluginSubscription ||
        (globalProps.value.user.plugin_trial_ends_at &&
            new Date(globalProps.value.user.plugin_trial_ends_at) > new Date())
    ) {
        router.post(
            route('plugin.enable'),
            {},
            {
                preserveScroll: true,
                onSuccess: () => {
                    create({
                        title: 'Plugin enabled',
                        text: 'Plugin has been successfully enabled.',
                        type: 'success',
                    });
                },
                onError: () => {
                    create({
                        title: 'Plugin not enabled',
                        text: 'There was an error enabling your Plugin.',
                        type: 'error',
                    });
                },
            }
        );
    } else router.get(route('billing.plugin-subscriptions.index'));
};

const disablePlugin = async () => {
    const confirmed = await showConfirmation({
        header: 'Disable Plugin',
        message:
            'When Plugin is disabled, all of your API tokens will automatically expire. As a result, you will no longer be able to initialize the TOPOL.io editor in your application.',
        type: 'danger',
        confirm: 'Disable Plugin',
    });

    if (!confirmed) {
        return;
    }

    router.post(
        route('plugin.disable'),
        {},
        {
            preserveScroll: true,
            onStart: () => {
                loading.value = true;
            },
            onSuccess: () => {
                create({
                    title: 'Plugin disabled',
                    text: 'Plugin has been successfully disabled.',
                    type: 'success',
                });
                deleteConfirmation.value = false;
            },
            onError: () => {
                create({
                    title: 'Plugin not disabled',
                    text: 'There was an error disabling your Plugin.',
                    type: 'error',
                });
            },
            onFinish: () => {
                loading.value = false;
            },
        }
    );
};

const showRemoveTokenModal = (id: string) => {
    const token = loadedTokens.value.find((a) => a.id === id);
    if (token) {
        selectedToken.value = token;
    }
    selectedTokenId.value = id;
    removeTokenModal.value = true;
};

const closeCreateTokenModal = () => {
    createTokenModal.value = false;
    router.visit(route('plugin.api-tokens.index'), { preserveScroll: true });
};

const removeToken = async () => {
    removeTokenLoading.value = true;

    try {
        const res = await axios.delete(
            route('plugin.api-tokens.delete', {
                apiToken: selectedTokenId.value,
            })
        );
        if (res.status === 204) {
            create({
                title: 'API Token removed',
                text: 'API Token has been successfully removed.',
                type: 'success',
            });
            router.visit(route('plugin.api-tokens.index'), {
                preserveScroll: true,
            });
            removeTokenModal.value = false;
        }
    } catch (err) {
        return;
    } finally {
        removeTokenLoading.value = false;
    }
};
</script>
